import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './components/login/login.component';
import { SignupComponent } from './components/signup/signup.component';
import { MatInputModule } from "@angular/material/input";
import { CustomFormsModule } from "ng2-validation";
import { MatSelectModule } from "@angular/material/select";

import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from '../resetpassword/reset-password.component';

import { EmailSendComponent } from './components/email-send/email-send.component';
import { SharedModule } from '../shared/shared.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'signup', component: SignupComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'email-send', component: EmailSendComponent },
  { path: '', redirectTo: 'login', pathMatch: 'full' },

];



@NgModule({
  declarations: [
    LoginComponent,
    SignupComponent,
    ForgotPasswordComponent,
    EmailSendComponent,
    ResetPasswordComponent
  ],
  imports: [
    MatIconModule,
    MatFormFieldModule,
    CustomFormsModule,
    CommonModule,
    MatSelectModule,
    MatInputModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    ModalModule.forRoot(),
    RouterModule.forChild(routes)
  ],
})
export class AuthModule { }
